import React from 'react';
import './StatusBadge.css';

const STATUS_CONFIG = {
    // Project statuses
    active: { label: 'Aktiv', cssClass: 'active' },
    paused: { label: 'Inaktiv', cssClass: 'paused' }, // Also known as 'Pausiert' in some places
    completed: { label: 'Abgeschlossen', cssClass: 'completed' },
    archived: { label: 'Archiv', cssClass: 'archived' },
    deleted: { label: 'Gelöscht', cssClass: 'deleted' },
    
    // Customer statuses
    aktiv: { label: 'Aktiv', cssClass: 'active' },
    inaktiv: { label: 'Inaktiv', cssClass: 'paused' },

    // German/Leader statuses
    pausiert: { label: 'Pausiert', cssClass: 'paused' },
    abgeschlossen: { label: 'Abgeschlossen', cssClass: 'completed' },
    geloescht: { label: 'Gelöscht', cssClass: 'deleted' },
    undatiert: { label: 'Undatiert', cssClass: 'default' },
};

/**
 * A highly reusable status badge component with consistent Apple-like styling.
 * Automatically maps standard status strings to their respective colors and labels.
 * 
 * @param {Object} props
 * @param {string} props.status - The raw status string (e.g. 'active', 'paused', 'aktiv')
 * @param {string} [props.label] - Optional override for the label text
 * @param {string} [props.className] - Optional extra CSS classes
 */
export default function StatusBadge({ status, label, className = '' }) {
    const config = STATUS_CONFIG[status] || { label: status, cssClass: 'default' };
    
    return (
        <span className={`shared-status-badge ${config.cssClass} ${className}`}>
            {label || config.label}
        </span>
    );
}
